import React from 'react'
import { PersistGate } from 'redux-persist/es/integration/react'
import { Provider } from 'react-redux'
import { store, persistor } from '../redux/store'
import Routes from '../navigation'

const App = () => {

  return (
    <Provider store={store}>
      <PersistGate loading={<div>cargando ...</div>} persistor={persistor} >
        <Routes />
      </PersistGate>
    </Provider>
  )
}

export default App
